import { FilterList } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FiltersButtonProps } from './types';

const FiltersButton: React.FunctionComponent<FiltersButtonProps> = (props) => {
  const { onClick, title } = props;
  const { t } = useTranslation('common');

  return (
    <Tooltip title={title ?? t('filters')}>
      <IconButton size='small' onClick={onClick}>
        <FilterList fontSize='small' />
      </IconButton>
    </Tooltip>
  );
};

export default FiltersButton;
